import styles from './app-switcher-title.module.scss';
import { AppSwitcherSvg } from '../../icons/app-switcher.svg';
import React, { Fragment } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export function AppSwitcherTitle({ active }: { active: boolean }) {
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      defaultShow={false}
      key="auto-start"
      placement="bottom"
      delay={{ show: 250, hide: 400 }}
      overlay={
        active ? (
          <Fragment></Fragment>
        ) : (
          <Tooltip className={styles['tooltip']}>
            Access all your Power BI report
          </Tooltip>
        )
      }
    >
      <div
        className={`${styles['app-switcher-title']} ${
          active ? styles['active'] : ''
        }`}
      >
        <AppSwitcherSvg color={'rgba(21, 22, 26, 0.85)'} />
        <span className={styles['title']}>My Apps</span>
      </div>
    </OverlayTrigger>
  );
}
